export interface Article {
  slug: string;
  title: string;
  cover: string;
  category: string;
  categoryName: string;
  excerpt: string;
  content: string[];
  date: string;
  views: number;
  author: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: "rexue-manhua-tuijian",
    title: "2026 年十大热血漫画推荐，燃到不行的冒险神作大盘点",
    cover:
      "https://readdy.ai/api/search-image?query=collage%20of%20fiery%20shonen%20manga%20covers%20with%20blazing%20orange%20flames%20and%20dynamic%20action%20poses%2C%20warm%20vibrant%20palette%2C%20stylized%20anime%20artwork%2C%20clean%20dark%20background%20with%20embers&width=1200&height=675&seq=art-01&orientation=landscape",
    category: "rexue-maoxian",
    categoryName: "热血冒险",
    excerpt:
      "从永不言弃的少年成长，到燃到极致的战斗场面，这里整理了今年最值得一看的热血冒险漫画，让你一次看个够。",
    content: [
      "热血冒险漫画一直是漫画世界中经久不衰的题材，那些为梦想而战、为守护而燃烧的少年们，总能唤起读者内心深处的热血与共鸣。",
      "2026 年，热血冒险题材依旧佳作频出。从传统王道热血到创新战斗设定，各路作品在画风、剧情与世界观构建上都带来了新的惊喜。",
      "本篇文章我们整理了本年度人气与口碑俱佳的十部热血冒险漫画，涵盖经典续作与崭新力作，并附上题材分类与人气排行，帮助你在茫茫漫画海洋中快速锁定心仪之作。",
      "无论是偏爱酣畅淋漓的战斗场面，还是钟情于细腻深刻的角色成长，这份热血冒险漫画推荐大全都能为你提供参考。点击分类导航即可查看更多同类漫画。",
      "如果你对某一部作品心动，别忘了通过文章页与分类页的链接深入了解，也可以查阅我们的漫画排行榜大全，掌握当下最热门的人气排行。",
    ],
    date: "2026-08-10",
    views: 23500,
    author: "漫途编辑部",
    tags: ["热血", "推荐", "排行榜"],
  },
  {
    slug: "xuanhuan-xiuxian-lanshang",
    title: "玄幻修仙漫画人气榜：九霄剑尘为何长期霸榜",
    cover:
      "https://readdy.ai/api/search-image?query=epic%20xianxia%20cultivation%20manga%20scene%20of%20a%20swordsman%20on%20a%20flying%20sword%20among%20golden%20clouds%20and%20mountain%20peaks%2C%20warm%20gold%20and%20jade%20tones%2C%20stylized%20anime%20artwork%2C%20clean%20heavenly%20background&width=1200&height=675&seq=art-02&orientation=landscape",
    category: "xuanhuan-xiuxian",
    categoryName: "玄幻修仙",
    excerpt:
      "玄奂修仙题材长期占据漫画人气排行的头部位置，究竟背后有哪些规律与魅力，让我们一探究竟。",
    content: [
      "玄幻修仙作为华语漫画最具特色的题材之一，凭借宏大的世界观、清晰的成长体系和热血爽快的剧情，始终稳坐漫画人气排行的前列。",
      "在众多修仙漫画中，《九霄剑尘》凭借扎实的剧情、鲜明的人物与惊艳的战斗分镜，长期占据人气排行榜首，成为无数读者追更的日常。",
      "从废柴逆袭到问鼎剑道，这类题材满足了读者对成长与逆袭的强烈代入感，也让玄幻修仙成为漫画类型大全中最受欢迎的类别之一。",
      "在漫画分类大全中，玄幻修仙的题材分类之下汇聚了大量人气作品，无论你是资深书虫还是刚入坑的新手，都能在这里找到心头好。",
      "我们持续更新漫画排行榜大全与人气排行数据，欢迎通过首页分类导航与文章页持续关注最新动态。",
    ],
    date: "2026-08-08",
    views: 19800,
    author: "漫途编辑部",
    tags: ["玄幻", "修仙", "人气榜"],
  },
  {
    slug: "xiaoyuan-qingchun-huainian",
    title: "校园青春漫画推荐：回到那个蝉鸣不止的夏天",
    cover:
      "https://readdy.ai/api/search-image?query=nostalgic%20school%20youth%20manga%20scene%20of%20friends%20under%20a%20warm%20golden%20sunset%20in%20a%20schoolyard%2C%20soft%20yellow%20and%20amber%20tones%2C%20stylized%20anime%20artwork%2C%20clean%20bright%20background&width=1200&height=675&seq=art-03&orientation=landscape",
    category: "xiaoyuan-qingchun",
    categoryName: "校园青春",
    excerpt:
      "课桌、操场与青涩心动，校园青春漫画用温柔笔触记录下每个人回不去的少年时光。",
    content: [
      "校园青春漫画以贴近生活的故事与细腻的情感刻画，成为无数读者心中的「白月光」。它们记录下友谊、梦想与成长的闪亮瞬间。",
      "从热烈张扬的社团活动，到藏在课桌抽屉里的青涩情书，校园题材总能用最柔软的方式触动人心，让人想起自己的青春岁月。",
      "本文整理了多部人气与口碑俱佳的校园青春漫画，并按题材分类为你梳理，方便在漫画分类大全中快速找到想看的那一部。",
      "青春稍纵即逝，但好的作品能让美好定格。欢迎通过我们的漫画排行榜大全，发现更多值得一看的校园佳作。",
      "如果你对校园青春充满怀念，不妨点开分类页，沉浸式回顾那段蝉鸣不止的夏天。",
    ],
    date: "2026-08-05",
    views: 17600,
    author: "漫途编辑部",
    tags: ["校园", "青春", "推荐"],
  },
  {
    slug: "xuanyi-tuili-shaonao",
    title: "悬疑推理漫画烧脑合集：层层反转让你猜不到结局",
    cover:
      "https://readdy.ai/api/search-image?query=moody%20mystery%20manga%20scene%20of%20a%20detective%20with%20magnifying%20glass%20in%20a%20foggy%20noir%20city%2C%20dramatic%20amber%20and%20deep%20teal%20lighting%2C%20stylized%20anime%20artwork%2C%20clean%20dark%20background&width=1200&height=675&seq=art-04&orientation=landscape",
    category: "xuanyi-tuili",
    categoryName: "悬疑推理",
    excerpt:
      "喜欢烧脑与反转的读者不可错过，这份悬疑推理漫画合集带你层层逼近真相。",
    content: [
      "悬疑推理漫画的魅力，在于一步步铺垫、一次次反转，让读者在抽丝剥茧的过程中享受解谜的快感与惊喜。",
      "优秀的悬疑作品往往在细节处埋下伏笔，在结尾处带来恍然大悟的震撼，让人忍不住反复回看。",
      "本合集精选多部人气悬疑推理漫画，题材覆盖本格推理、社会派推理与心理悬疑，总有一部能让你欲罢不能。",
      "在漫画分类大全的悬疑推理分类中，还有更多烧脑作品等待你去探索。别忘了关注我们的漫画人气排行，看看大家都在追哪部。",
      "如果你喜欢挑战自己的推理能力，这部悬疑推理漫画推荐大全一定不容错过。",
    ],
    date: "2026-08-02",
    views: 16100,
    author: "漫途编辑部",
    tags: ["悬疑", "推理", "烧脑"],
  },
  {
    slug: "kehuan-jijia-weilai",
    title: "科幻机甲漫画的未来：从热血机器到星际史诗",
    cover:
      "https://readdy.ai/api/search-image?query=futuristic%20mecha%20manga%20scene%20of%20a%20giant%20robot%20on%20a%20space%20colony%20at%20dusk%2C%20warm%20orange%20and%20steel%20blue%20tones%2C%20stylized%20anime%20artwork%2C%20clean%20high%20contrast%20background&width=1200&height=675&seq=art-05&orientation=landscape",
    category: "kehuan-jijia",
    categoryName: "科幻机甲",
    excerpt:
      "科幻机甲漫画以宏大设定与震撼战斗见长，让我们一同展望这一题材的未来发展。",
    content: [
      "科幻机甲漫画将钢铁巨兽与未来科技完美结合，用宏大的世界观与震撼的战斗场面，为读者开启通往星际的想象之门。",
      "从地球保卫战到星际远征，科幻机甲题材不断拓展叙事的边界，在热血战斗之外也深刻探讨着人性、战争与和平等命题。",
      "随着创作技术的进步，近年来的科幻机甲漫画在画面表现力与剧情深度上都有了长足发展，涌现出众多人气佳作。",
      "在漫画类型大全的科幻机甲分类中，你可以找到本年度最值得关注的机甲作品，并参考我们的漫画排行榜大全挑选心头好。",
      "如果你对钢铁与星空的浪漫情有独钟，这部科幻机甲漫画推荐一定会让你热血沸腾。",
    ],
    date: "2026-07-28",
    views: 13900,
    author: "漫途编辑部",
    tags: ["科幻", "机甲", "未来"],
  },
  {
    slug: "lianai-manhua-zheli",
    title: "恋爱言情漫画里的心动瞬间：治愈系纯爱神作盘点",
    cover:
      "https://readdy.ai/api/search-image?query=sweet%20romance%20manga%20scene%20of%20a%20couple%20under%20falling%20cherry%20blossoms%20at%20dusk%2C%20gentle%20warm%20pink%20and%20peach%20tones%2C%20stylized%20anime%20artwork%2C%20clean%20soft%20background&width=1200&height=675&seq=art-06&orientation=landscape",
    category: "lianai-yanqing",
    categoryName: "恋爱言情",
    excerpt:
      "从双向暗恋到治愈救赎，恋爱言情漫画用细腻笔触描绘出最动人的心动瞬间。",
    content: [
      "恋爱言情漫画擅长用细腻的笔触与温柔的叙事，刻画那些让人心跳加速的心动瞬间与双向奔赴的美好。",
      "无论是校园里的青涩暗恋，还是都市中的救赎与治愈，恋爱题材总能以最柔软的方式抚慰读者的心灵。",
      "本文整理了多部人气治愈系纯爱神作，按题材分类呈现，帮助你在漫画分类大全中快速锁定心仪的爱情故事。",
      "在漫画人气排行的恋爱言情板块，你还能发现更多值得一读的佳作，感受不同作者笔下的心动与温暖。",
      "如果你正在寻找一部能让你怦然心动的漫画，这份恋爱言情推荐大全一定不会让你失望。",
    ],
    date: "2026-07-24",
    views: 15200,
    author: "漫途编辑部",
    tags: ["恋爱", "纯爱", "治愈"],
  },
];